var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MediaResolver,{attrs:{"src":_setup.properSrc,"mime-type":_setup.properType,"poster":_vm.poster,"preview":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }